import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input,
  OnChanges,
  SimpleChanges,
  OnDestroy,
  Output, EventEmitter
} from '@angular/core';
import {Profile} from "../../../common/common-profile/models/profile.model";
import {Product} from "../../models/product.model";
import {ProductVariantShort} from "../../../common/common-product/models/product-short.model";
import {Contract} from "../../../snatch/models/contract.model";
import { Observable, Subject } from "rxjs";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import { distinctUntilChanged, flatMap, takeUntil } from "rxjs/operators";
import {ProductVariantPricing} from "../../../common/common-product/models/product-variant-pricing.model";
import { Select, Store } from "@ngxs/store";
import {
  AddOrderTemplateItem,
  CreateOrderTemplate,
  FetchOrderTemplatesMin
} from "../../actions/product-details.actions";
import {
  ClearOrderTemplateState
} from "../../../order-templates/actions/order-templates.actions";
import { Router } from "@angular/router";

@Component({
  selector: 'leap-product-add-order-templates',
  templateUrl: './product-add-order-templates.component.html',
  styleUrls: ['./product-add-order-templates.component.less', '../../styles/tab-content.less'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductAddOrderTemplatesComponent implements OnInit, OnDestroy, OnChanges{

  @Input() profile: Profile;
  @Input() product: Product;
  @Input() selectedVariant: ProductVariantShort;
  @Input() expiringContract: Contract;
  @Input() details: Product;

  @Input() currencySignsMap$: Observable<Map<string, string>>;
  @Input() orderTemplatePricing: any;

  @Input() currencySign: any;
  @Input() basePrice: any;
  @Input() surchargeTotalAmount: any;

  @Output() onProductQuantityChange = new EventEmitter();
  @Output() onModalClose: EventEmitter<any> = new EventEmitter<any>();

  @Select((state: any) => state.productDetails.createOrderTemplatePending) createOrderTemplatePending$: Observable<boolean>;
  @Select((state: any) => state.productDetails.createOrderTemplateError) createOrderTemplateError$: Observable<boolean>;
  @Select((state: any) => state.productDetails.orderTemplatesList) orderTemplatesList$: Observable<Array<any>>;

  @Select((state: any) => state.productDetails.fetchOrderTemplatesMinPending) fetchOrderTemplatesMinPending$: Observable<boolean>;
  @Select((state: any) => state.productDetails.fetchOrderTemplatesMinSuccess) fetchOrderTemplatesMinSuccess$: Observable<boolean>;
  @Select((state: any) => state.productDetails.fetchOrderTemplatesMinError) fetchOrderTemplatesMinError$: Observable<any>;

  @Select((state: any) => state.productDetails.addOrderTemplateItemPending) addOrderTemplateItemPending$: Observable<any>;

  form: FormGroup;

  ngUnsubscribe = new Subject();
  newPricingDetails: OrderTemplatePricing = null;

  constructor(private fb: FormBuilder, private store: Store, private router: Router) {
    this.store.dispatch(new FetchOrderTemplatesMin());
  }

  ngOnInit(): void {
    this.fetchPricingForQuantity(1);

    this.form = this.fb.group({
      'quantity' : [1, [Validators.required, Validators.min(1)]],
      'newTemplateName' : [null, [Validators.required, Validators.maxLength(120)]]
    });
    this.form.get('quantity').valueChanges.pipe(
        takeUntil(this.ngUnsubscribe),
        distinctUntilChanged())
      .subscribe(_ => this.fetchPricingForQuantity(_));
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.orderTemplatePricing &&
        changes.orderTemplatePricing.currentValue &&
        changes.orderTemplatePricing.currentValue.hasOwnProperty(this.selectedVariant.sku)) {
      this.newPricingDetails = changes.orderTemplatePricing.currentValue[this.selectedVariant.sku]
    }
  }

  addProductToOrderTemplate(templateName: string): void {
    this.store.dispatch(new AddOrderTemplateItem({sku: this.selectedVariant.sku, quantity: this.form.get('quantity').value, orderTemplate: templateName}))
      .pipe(
        flatMap(() => this.store.dispatch(new FetchOrderTemplatesMin())))
      .subscribe(data => {});
  }

  fetchPricingForQuantity(quantity) {
    this.onProductQuantityChange.emit({sku: this.selectedVariant.sku, quantity: quantity});
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  createTemplate(): void {
    this.store.dispatch(new CreateOrderTemplate(this.form.controls.newTemplateName.value))
      .pipe(flatMap(() => this.store.dispatch(new FetchOrderTemplatesMin())))
      .subscribe(data => {
        this.form.reset();
        this.form.controls.quantity.setValue(1)
      });
  }

  clearState(): void {
    this.store.dispatch(new ClearOrderTemplateState());
  }
  includeSelectedVariant(template: any) {
    if (template != null && template.items.length > 0) {
      let items = template.items.filter(el => el.sku == this.selectedVariant.sku);
      return  items.length > 0;
    }
    return false
  }

  variantQuantityInTemplate(template: any) {
    let item = template.items.find(el => el.sku == this.selectedVariant.sku);
    return item.quantity;
  }

  closeModal() {
    this.onModalClose.emit();
  }

  goToTemplateDetails(id: string) {
    this.router.navigate(['order-templates','details', id]);
  }
}

export interface OrderTemplatePricing {
  quantity : number,
  pricing : ProductVariantPricing
}
